import { useI18n } from 'vue-i18n';
import { object, string } from 'yup';
import router from '@/router';
import { useField, useForm } from 'vee-validate';

export const useCustomerBankAccountForm = () => {
  const { t } = useI18n();

  const validationSchema = object({
    ownerName: string().required().max(100).label(t('suppliers.titles.account_holder')),
    bankName: string().required().max(100).label(t('suppliers.titles.bank_name')),
    swiftCode: string().required().max(50).label(t('suppliers.titles.swift_placeholder')),
    iban: string().required().max(50).label(t('suppliers.titles.iban')),
    customerId: string()
      .required()
      .label(t('suppliers.titles.customer'))
      .typeError(t('suppliers.titles.customer_required')),
  });

  const {
    errors,
    handleSubmit,
    isSubmitting,
    meta,
    resetForm,
    setValues,
    resetField,
    setFieldValue,
  } = useForm({
    validationSchema,
  });

  const { value: ownerName } = useField('ownerName');
  const { value: bankName } = useField('bankName');
  const { value: swiftCode } = useField('swiftCode');
  const { value: iban } = useField('iban');
  const { value: customerId } = useField('customerId');

  const backToBankAccountsList = () => {
    router.push({ name: 'list-customer-bank-accounts' });
  };

  return {
    errors,
    handleSubmit,
    isSubmitting,
    meta,
    resetForm,
    setValues,
    ownerName,
    bankName,
    swiftCode,
    iban,
    customerId,
    backToBankAccountsList,
    resetField,
    setFieldValue,
  };
};
